/* Copyright (c) 2020-present CloudIO Inc */

import { atom } from '@cloudio-saas/statex';
import { observable } from '@legendapp/state';

export interface RouteData {
  app: string;
  page: string;
  role: string | null;
  home: boolean;
  params: Record<string, string>;
  paramString: string;
}

const routeAtom = atom<RouteData>({
  path: ['url', 'route'],
  defaultValue: {
    app: '',
    page: '',
    home: false,
    role: null,
    params: {},
    paramString: '',
  },
});

const urlParamsAtom = atom<Record<string, unknown>>({
  path: ['url', 'params'],
  defaultValue: {},
});

export const routeSignal = observable<{
  route: RouteData;
}>({
  route: {
    app: '',
    page: '',
    home: false,
    role: null,
    params: {},
    paramString: '',
  },
});

export { routeAtom, urlParamsAtom };
